import type { ComponentType, RefObject } from "react";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import type { SvgIcon, SvgIconProps } from "@mui/material";
import type { SxProps, Theme } from "@mui/material/styles";

export interface ArrowIconProps extends Partial<SvgIconProps> {
  right?: boolean;
  left?: boolean;
  up?: boolean;
  down?: boolean;
  size?: number | string;
  className?: string;
  sx?: SxProps<Theme>;
  Icon?: typeof SvgIcon | ComponentType<SvgIconProps>;
  ref?: RefObject<SVGSVGElement>;
}

const ArrowIcon = ({
  right,
  left,
  up,
  down,
  size = 12,
  className,
  Icon,
  sx,
  ref,
  ...props
}: ArrowIconProps) => {
  const getRotation = (): string => {
    if (left) return "180deg";
    if (up) return "-90deg";
    if (down) return "90deg";
    return "0"; // default to right
  };

  const RenderedIcon = Icon || ArrowForwardIosIcon;
  const rotation = getRotation();

  const sxProp: SxProps<Theme> = {
    fontSize: size,
    transition: "transform 150ms",
    transform: `rotate(${rotation})`,
    ".group\\/arrow:hover &": {
      transform: `rotate(${rotation}) translateX(3px)`,
    },
    ...sx,
  };

  return (
    <RenderedIcon
      ref={ref}
      className={className}
      color="action"
      sx={sxProp}
      data-test-id="arrow-forward-icon"
      {...props}
    />
  );
};

export default ArrowIcon;
